<!--
 * @LastEditors: YGQ
 * @LastEditTime: 2026-09-18 18:09:39
 * @FilePath: /oneid/src/views/home/components/DialogAlipay.vue
 * @Description: 授权码弹框（生成 / 展示 / 复制 / 重置 / 停用）
-->
<template>
  <el-dialog
    title="授权码"
    width="480px"
    custom-class="dialog"
    :visible="visible"
    :before-close="onHide"
    :show-close="closable"
    :close-on-click-modal="closable"
    :close-on-press-escape="closable"

  >
    <div class="dialog-content">
      <el-alert
        class="custom-alert"
        show-icon
        title="为保证账号安全，请定期重置授权码"
        type="warning"
        :closable="false"
      />

      <transition name="btn-fade-scale" mode="out-in">
        <!-- 无授权码状态：生成授权码 -->
        <div v-if="!hasCode" key="empty" class="state-block">
          <div class="code-box is-disabled">
            <span class="code-placeholder">暂无可用的授权码</span>
          </div>
          <el-button
            class="action-btn primary-btn is-full"
            type="primary"
            :loading="isActionLoading"
            @click="onGenerate"
          >
            {{ isActionLoading ? "正在生成" : "生成授权码" }}
          </el-button>
        </div>

        <!-- 有授权码状态：展示 + 复制 + 左右并排双按钮 -->
        <div v-else key="has" class="state-block">
          <div class="code-box">
            <span class="code-text">{{ authorizationCode }}</span>
            <el-button type="text" class="copy-btn" @click="onCopy">复制</el-button>
          </div>

          <div class="btn-group">
            <el-button
              class="action-btn primary-btn"
              type="primary"
              :loading="isActionLoading"
              @click="onReset"
            >
              重置授权码
            </el-button>
            <el-button
              class="action-btn danger-btn"
              type="danger"
              :loading="isActionLoading"
              @click="onCancel"
            >
              停用授权码
            </el-button>
          </div>
        </div>
      </transition>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "DialogAlipay",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: true,
    },
    // 当前授权码（由父组件传入，空串表示无）
    authorizationCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isActionLoading: false,
    };
  },
  computed: {
    // 是否存在授权码
    hasCode() {
      return !!this.authorizationCode;
    },
  },
  methods: {

    /**
     * 生成/重置/停用成功后，把最新授权码回传父组件
     * @param {Object} res - 接口返回的 data
     */
    applyCode(res) {
      this.$emit("update", (res && res.authorizationCode) || "");
    },

    /**
     * 无授权码时：生成授权码
     */
    async onGenerate() {
      if (this.isActionLoading) return;
      this.isActionLoading = true;
      const [res, err] = await this.$post("resetAuthorizationCode");
      this.isActionLoading = false;
      if (err) return this.$msg(err);
      this.applyCode(res);
      this.$msg.success("授权码生成成功");
    },

    /**
     * 有授权码时：重置授权码
     */
    async onReset() {
      if (this.isActionLoading) return;
      this.isActionLoading = true;
      const [res, err] = await this.$post("resetAuthorizationCode");
      this.isActionLoading = false;
      if (err) return this.$msg(err);
      this.applyCode(res);
      this.$msg.success("授权码已重置");
    },

    /**
     * 有授权码时：停用授权码（二次确认）
     */
    onCancel() {
      if (this.isActionLoading) return;
      // this.$msgbox
      //   .confirm("停用后授权码将无法使用，确定要停用吗？", "停用授权码", {
      //     confirmButtonText: "确定停用",
      //     cancelButtonText: "再想想",
      //     type: "warning",
      //   })
      //   .then(() => this.cancelAuthorizationCode())
      //   .catch(() => {});
      this.cancelAuthorizationCode();
    },

    /**
     * 执行停用授权码请求
     */
    async cancelAuthorizationCode() {
      this.isActionLoading = true;
      const [res, err] = await this.$post("cancelAuthorizationCode");
      this.isActionLoading = false;
      if (err) return this.$msg(err);
      this.applyCode(res);
      this.$msg.success("授权码已停用");
    },

    /**
     * 复制授权码
     */
    onCopy() {
      this.$copyText(this.authorizationCode)
        .then(() => this.$msg.success("复制成功"))
        .catch(() => this.$msg("复制失败，请手动复制"));
    },

    /**
     * 关闭弹框
     */
    onHide() {
      this.$emit("hide");
    },
  },
};
</script>

<style scoped>

.dialog-content {
  padding: 0 8px 24px;
}

/* 顶部安全警示条 */
.custom-alert {
  background-color: #fef7ed !important;
  border: none;
  border-radius: 8px;
  padding: 10px 14px;
}

.state-block {
  margin-top: 18px;
}

/* 授权码展示框 */
.code-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 46px;
  margin-bottom: 18px;
  padding: 0 16px;
  background-color: #f7f9fb;
  border: 1px solid #dfe3eb;
  border-radius: 8px;
  box-sizing: border-box;
}

.code-box.is-disabled {
  justify-content: center;
}

.code-placeholder {
  font-size: 14px;
  color: #b0b4bc;
}

.code-text {
  font-size: 14px;
  font-weight: 600;
  color: #1f2329;
  letter-spacing: 0.5px;
  user-select: all;
}

.copy-btn {
  color: #268aff !important;
  font-size: 14px;
  padding: 0;
  border: none;
}

/* 底部操作按钮 */
.btn-group {
  display: flex;
  gap: 16px;
}

.action-btn {
  height: 44px;
  font-weight: 400;
  border-radius: 8px;
  border: none !important;
  transition: opacity 0.2s ease, transform 0.1s ease;
  box-sizing: border-box;
}

.action-btn:active {
  transform: translateY(1px);
}

.action-btn.is-full {
  width: 100%;
}

.btn-group .action-btn {
  flex: 1;
  margin: 0;
}

/* 蓝色主操作按钮（生成/重置） */
.primary-btn {
  background: linear-gradient(108deg, #01c7ff 0%, #0296ff 101%) !important;
  color: #ffffff !important;
}

.primary-btn:hover {
  opacity: 0.9;
}

/* 橙红色危险操作按钮（停用） */
.danger-btn {
  background: linear-gradient(108deg, #f17f5f 0%, #e84548 101%) !important;
  color: #ffffff !important;
}

.danger-btn:hover {
  opacity: 0.9;
}

/* 状态切换淡入淡出动画 */
.btn-fade-scale-enter-active,
.btn-fade-scale-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-fade-scale-enter {
  opacity: 0;
  transform: scale(0.98);
}

.btn-fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.98);
}
</style>
